import { Component, OnInit, ElementRef, AfterContentInit, AfterViewInit, OnChanges, DoCheck  } from '@angular/core';
import { DwComponent, DwComponentType, DwContainerOptions, DwSecurityUserService, DwSectionBaseComponent } from '@devwareapps/devware-cap';
import { PermitsMetaDataItemNames } from '../../meta-data/permits-meta-data.service';
import { PermitsV2MetaDataItemNames } from '../../meta-data/permitsv2-meta-data.service';
import { WachterUserExt } from '../../../../shared/models/wachter-user.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';

@DwComponent(
  {
    key: 'permits-rush-grid',
    name: 'Permits Rush Grid',
    componentType: DwComponentType.pageComponent,
    isGlobal: true,
  }
)
@Component({
  selector: 'app-permit-rush-grid',
  template: `
  <dw-container [options]="containerOptions" *ngIf="showGrid">
    <span header>
      Rush Requests {{showingCount}}
    </span>
    <div body>
      <dw-meta-data-grid [item]="permitsItem" configKeyPart="rush-permits"></dw-meta-data-grid>
    </div>
  </dw-container>
  <div style="margin-bottom: 10px"></div>
  `
})
export class PermitRushGridComponent 
  implements OnInit, DoCheck {
  permitsItem = PermitsV2MetaDataItemNames.Permits2Permit;
  containerOptions: DwContainerOptions = {
    styleName: 'wachter_red_full_width',
    containerAllowCollapse : true,
    containerCollapseDefault: true,
    useContainerStyling: true,
    showTitle: true,
  };
  showGrid: boolean = false;
  showingCount: string = "";
  constructor(private dwSecurityUserService: DwSecurityUserService,
              private el: ElementRef) { }

  ngOnInit(): void {
    this.showGrid = this.dwSecurityUserService.hasPermission(AppPermissions.permitAdmin) ||
                    this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeCriticalPowerGrid) ||
                    this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeNESGrid) ||
                    this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeNSPGrid) ||
                    this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeOperationsSupportGrid) ||
                    this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeRolloutGrid) ||
                    this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeWECGrid);
  }
  ngDoCheck(): void{
    if (this.el.nativeElement.innerHTML.indexOf("count-panel") > -1){
      const countPanel = this.el.nativeElement.querySelector('.count-panel');
      const countText = countPanel ? countPanel.innerText : "";
      const count = countText.indexOf("Showing ") > -1 ? countText.split(' ') : null;
      this.showingCount = count ? "(" + count[1] + ")" : "(0)";
    }
  }
}
